import { render, staticRenderFns } from "./PalmsCareType.html?vue&type=template&id=48fe0bbe&external"
import script from "./PalmsCareType.js?vue&type=script&lang=js&external"
export * from "./PalmsCareType.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports